const downloadIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <g class="icon-download" fill="#979797">
        <path d="M10,0.001 C4.486,0.001 0,4.486 0,10.001 C0,15.515 4.486,20.001 10,20.001 C15.514,20.001 20,15.515 20,10.001 C20,4.487 15.514,0.001 10,0.001 Z M10,18.001 C5.589,18.001 2,14.411 2,10.001 C2,5.589 5.589,2.001 10,2.001 C14.411,2.001 18,5.589 18,10.001 C18,14.412 14.411,18.001 10,18.001 Z"/>
        <polygon points="11 12.587 11 4.001 9 4.001 9 12.587 6.707 10.294 5.293 11.708 10 16.416 14.707 11.708 13.293 10.294"/>
      </g>
    </svg>
`;

export default downloadIcon;
